export default __webpack_public_path__ + "static/media/basic.d0b612fe.png";